import React from "react";

import { BreadcrumbContainer } from "./BreadcrumbContainer";
import { HeaderSectionV2Props } from "./ProductHeaderSection";
import { ProductHeaderV2 } from "./ProductHeaderV2";

export const HeaderSectionContent = (props: HeaderSectionV2Props) => {
    const {
        title,
        minPrice,
        reviewRating,
        reviewCount,
        cancellationPolicy,
        guidePriceType,
        availability,
        breadcrumbs,
        guidePricePricingData,
    } = props;
    const hasFreeCancellation = cancellationPolicy?.hasFreeCancellation ?? false;

    return (
        <>
            {breadcrumbs && <BreadcrumbContainer>{breadcrumbs}</BreadcrumbContainer>}
            <ProductHeaderV2
                title={title}
                minPrice={minPrice}
                reviewRating={reviewRating}
                reviewCount={reviewCount}
                hasFreeCancellation={hasFreeCancellation}
                guidePriceType={guidePriceType}
                availability={availability}
                guidePricePricingData={guidePricePricingData}
            />
        </>
    );
};
